import { useNavigate, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Pagination } from '@mui/material';
import { useGetReviewsQuery } from '../features/api/rest/apiReviewsSlice';
import ReviewCard from './ReviewCard';
import Spinner from './Spinner';
import Error from './Error';

function ReviewsResults({ ean }) {
  const [searchParams] = useSearchParams();
  const reviewPage = parseInt(searchParams.get('page'), 10) || 1;
  const navigate = useNavigate();
  const reviewsForPage = 10;

  const { reviews, reviewsCount, isLoading, isFetching, isError } = useGetReviewsQuery(
    { ean, mine: false, page: reviewPage },
    {
      selectFromResult: ({ data }) => ({
        reviews: data?.results,
        reviewsCount: data?.count,
      }),
    }
  );

  const handlePageChange = (nextPage) => {
    searchParams.set('page', nextPage);
    navigate(`/products/${ean}?${searchParams.toString()}`);
  };

  const pagination = reviewsCount > reviewsForPage && <Pagination sx={{ my: 2 }} count={Math.ceil(reviewsCount / reviewsForPage)} page={reviewPage} onChange={(event, newPage) => handlePageChange(newPage)} data-testid="Pagination" />;

  if (isLoading || isFetching) return <Spinner />;

  if (isError) return <Error />;

  return (
    <Box>
      {pagination}
      {reviews &&
        reviews.map((review, index) => {
          return <ReviewCard key={review.id} id={review.id} date={review.created} title={review.title} description={review.description} rating={review.rating} owner={review.owner} totScore={review.tot_score} numVotes={review.num_votes} ean={ean} />;
        })}
      {pagination}
    </Box>
  );
}

ReviewsResults.propTypes = {
  ean: PropTypes.string.isRequired,
};

export default ReviewsResults;
